<template>
  <div class="selected-intent-tags">
    <div class="multi-select__option-area" v-for="intent in selectedTags" :key="intent.id">
      <div class="multi-select__option-wrapper">
        <div class="multi-select__option multi-select__option--product">
          <div class="multi-select__option-name">
            <template v-if="intent.group"> {{ intent.group }}: {{ intent.name }}</template>
            <template v-else>{{ intent.name }}</template>
          </div>
          <div class="multi-select__option-remove-button" @click="removeIntent(intent.id)">
            <i class="icon-times"></i>
          </div>
        </div>
      </div>
      <button
        @click="showAdvancedFeatures(intent.id)"
        class="btn btn--square btn--quinary btn--square-xs advanced-options"
      >
        <i aria-hidden="true" class="icon-cogwheel"></i>
      </button>
      <advanced-options @resize="updateSize" @save="save" :intent="intent" v-if="intent.advancedOpen" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AdvancedOptions from './AdvancedOptions.vue';

export default {
  components: {
    AdvancedOptions,
  },
  props: {
    intent: { type: Object },
    type: { type: String },
  },
  computed: {
    ...mapGetters({
      selectedEnrichments: 'getSelectedEnrichments',
      selectedIntents: 'getSelectedIntents',
    }),

    selectedTags() {
      let tags = null;

      if (this.type === 'intents') {
        tags = this.selectedIntents;
      }

      if (this.type === 'enrichments') {
        tags = this.selectedEnrichments;
      }

      return tags;
    },
  },
  methods: {
    removeIntent(id) {
      this.$store.commit('removeIntent', id);

      this.save();
      this.updateSize();
    },

    showAdvancedFeatures(id) {
      const advancedIsOpen = this.$store.state.intents.find((intent) => intent.id === id).advancedOpen;

      if (advancedIsOpen) {
        this.$store.commit('hideAdvancedFeatures', id);
      } else {
        this.$store.commit('showAdvancedFeatures', id);
      }

      this.updateSize();
    },

    updateSize() {
      this.$emit('resize');
    },

    save() {
      this.$emit('save');
    },
  },
};
</script>
<style scoped>
.multi-select__option-name {
  text-overflow: initial;
}

.multi-select__option-area {
  margin: 0 0 1rem;
  border-bottom: 1px solid #ddd;
  padding: 0 0 1rem 0;
}

.multi-select__option-area:last-child {
  border: none;
}

.advanced-options {
  position: relative;
  top: 7px;
  left: 3px;
}
</style>
